import { render, staticRenderFns } from "./ConsultantsBySubVendor.vue?vue&type=template&id=984bc644&"
import script from "./ConsultantsBySubVendor.vue?vue&type=script&lang=js&"
export * from "./ConsultantsBySubVendor.vue?vue&type=script&lang=js&"
import style0 from "./ConsultantsBySubVendor.vue?vue&type=style&index=0&id=984bc644&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports